import { MessageCircle } from 'lucide-react';
import { BOOKING_URL, WHATSAPP_URL } from '../constants';
import { gsap, ScrollTrigger, useMotion } from '../lib/motion';

// Celular: barra fixa com agendamento + WhatsApp. Desktop: só o atalho de dúvidas.
export default function StickyActions() {
  // No celular a barra só entra quando o botão do topo sai da tela, sem repetir o CTA logo na abertura.
  const scope = useMotion((bar) => {
    const heroCta = document.getElementById('hero-cta');
    if (!heroCta) return;
    const slide = (yPercent) => gsap.to(bar, { yPercent, duration: 0.5, ease: 'power3.out', overwrite: true });
    gsap.set(bar, { yPercent: 110 });
    ScrollTrigger.create({
      trigger: heroCta,
      start: 'bottom top+=64',
      onEnter: () => slide(0),
      onLeaveBack: () => slide(110),
    });
    return () => gsap.set(bar, { clearProps: 'transform' });
  });

  return (
    <>
      <div
        ref={scope}
        className="md:hidden fixed inset-x-0 bottom-0 z-40 bg-paper/95 backdrop-blur-md border-t border-rule px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] flex gap-3"
        data-testid="mobile-booking-bar"
      >
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex justify-center items-center bg-ink text-paper py-3.5 rounded-full font-semibold active:scale-[0.98]"
          data-testid="mobile-booking-btn"
        >
          Agendar horário
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Tirar dúvidas pelo WhatsApp"
          className="w-[52px] inline-flex justify-center items-center rounded-full border border-ink/20 text-ink active:scale-[0.98]"
          data-testid="whatsapp-floating-btn"
        >
          <MessageCircle size={22} strokeWidth={1.75} />
        </a>
      </div>

      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-2 bg-raised text-ink border border-rule shadow-[0_8px_30px_rgb(0_0_0/0.08)] px-5 py-3 rounded-full text-sm font-semibold hover:border-ink transition-colors"
        data-testid="whatsapp-desktop-btn"
      >
        <MessageCircle size={18} strokeWidth={1.75} aria-hidden="true" />
        Dúvidas no WhatsApp
      </a>
    </>
  );
}
